import { UserCoreFragment, UserFlagType, UserState } from '../../../../__generated__/graphql';

interface Tag {
  content: string;
  bg: string;
  color: string;
}

export function getTagsForUser(user: UserCoreFragment, showFree = false) {
  const tags: Tag[] = [];

  if (user.state === UserState.DraftGuest) {
    tags.push({
      content: 'DRAFT USER',
      bg: 'brand.highlight',
      color: 'brand.background',
    });
  }

  if (user.flag.includes(UserFlagType.PerfectlyImperfect)) {
    tags.push({
      content: 'PI.FYI',
      bg: 'brand.highlight',
      color: 'brand.background',
    });
  } else if (user.flag.includes(UserFlagType.Guest)) {
    tags.push({
      content: 'Guest',
      bg: 'brand.highlight',
      color: 'brand.background',
    });
  }

  if (user.flag.includes(UserFlagType.Staff)) {
    tags.push({
      content: 'Staff',
      bg: 'brand.highlight',
      color: 'brand.background',
    });
  }

  if (!tags.length) {
    if (user.isPremium) {
      tags.push({
        content: 'Pro',
        bg: 'brand.highlight',
        color: 'brand.background',
      });
    } else if (showFree) {
      // tags.push({
      //   content: 'Free',
      //   bg: 'grey',
      //   color: 'brand.background',
      // });
    }
  }

  tags.push({
    content: 'Beta',
    bg: 'brand.highlight',
    color: 'brand.background',
  });

  return tags;
}
